// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "svg.app-logo[data-v-dc7b29e6]{display:block;width:7.3888888889em;height:1em;font-size:1.8rem;color:#ff6352}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
